import { ConversationMessagesRecord } from './ConversationMessagesRecord';
export class ConversationMessages {
    totalCount: number;
    pageSize: number;
    pageIndex: number;
    entityName: string;
    entityLogo: string;
    pageData: ConversationMessagesRecord[] = new Array();
}
